export default {
  buttons: {
    login: 'Kirjaudu',
  },
  feedback: {
    incorrect_code: 'Syöttämäsi koodi on virheellinen. Yritä uudelleen.',
    expired_code: 'Tämä koodi on vanhentunut. Pyydä uusi koodi.',
    too_many_attempts: 'Liian monta yritystä. Odota hetki ja yritä uudelleen.',
    unknown: 'Jokin meni pieleen koodin vahvistamisessa. Yritä uudelleen.',
    network_error: 'Emme saaneet yhteyttä palvelimeen. Tarkista yhteytesi ja yritä uudelleen.',
  },
};
